"use client";
import Image from "next/image";

function ForceCard({ link, icon, title, subtitle }) {
  return (
    <div onClick={() => window.location.href = link} className="cursor-pointer rounded-[18px] sm:rounded-[28px] bg-gradient-to-r from-[var(--gradient-start)] to-[var(--gradient-end-light)] p-4 sm:p-8 shadow-lg flex flex-col items-center min-w-0">
      <div className="h-16 w-full flex items-center justify-center sm:h-32">
        <Image
          src={icon}
          alt={title}
          width={64}
          height={48}
          className="sm:w-[160px] sm:h-[120px] w-[64px] h-[48px]"
        />
      </div>
      <h3 className="mt-3 sm:mt-6 text-center font-[BOOWIE] text-lg sm:text-2xl md:text-3xl tracking-wide font-bold">
        {title}
      </h3>
      <p className="mt-2 sm:mt-3 text-center text-xs sm:text-base opacity-80 font-semibold tracking-tighter">
        {subtitle}
      </p>
    </div>
  );
}

export default function FourForcesSection() {
  return (
    <section className="w-full py-2 md:py-14">
      <div className="mx-auto px-4 sm:px-12 lg:px-20 xl:px-32 2xl:px-48">

        {/* Heading row */}
        <div className="flex flex-col md:flex-row items-start justify-between gap-6 lg:gap-16 xl:gap-24">
          <div className="flex-1">
            {/* Inline small Artha image */}
            <div className="flex items-center gap-3">
              <Image
                src="/Artha.png"
                alt="Rupee"
                width={28}
                height={28}
                className="shrink-0"
              />
              <h2 className="font-[BOOWIE] text-3xl md:text-4xl lg:text-5xl font-semibold">
                THE FOUR FORCES
              </h2>
            </div>

            {/* Paragraph */}
            <p className="mt-4 max-w-xl text-base md:text-lg tracking-tighter leading-relaxed text-justify">
              At Gitartha, we don’t just offer services, we power a vision.
              A vision where every Indian, whether a dreamer, a doer, or a decision maker, finds strength in Finance, Legal, Realty, and Marketing under one roof. We are not just building businesses, we are shaping futures. We are building India.
            </p>
          </div>

          {/* Big Artha image */}
          <Image
            src="/Artha.png"
            alt="Rupee Mark"
            width={140}
            height={140}
            className="hidden md:block mt-1 shrink-0"
            priority
          />
        </div>

        {/* Four cards grid */}
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 xl:gap-8">
          <ForceCard link="https://tax.gitartha.in/" icon="/Graph.png" title="FINANCE" subtitle="The Force of Wealth" />
          <ForceCard link="https://legal.gitartha.in/" icon="/Law.png" title="LEGAL" subtitle="The Force of Law" />
          <ForceCard link="https://realty.gitartha.in/" icon="/House.png" title="REALTY" subtitle="The Force of Realty" />
          <ForceCard link="https://growth.gitartha.in/" icon="/Speaker.png" title="GROWTH" subtitle="The Force of Growth" />
        </div>
      </div>
    </section>
  );
}
